<template>
  <input v-model="maskedValue" :placeholder="placeholder" class="input-mascked" />
</template>

<script>
export default {
  name: "InputMask",
  props: {
    placeholder: String,
    value: String,
    maskT: String,
    masked: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    currentValue: "",
    currentMask: "",
    tokens: {
      "#": { pattern: /\d/ },
      S: { pattern: /[a-zA-Z]/ },
      A: { pattern: /[0-9a-zA-Z]/ },
      U: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
      L: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() }
    }
  }),
  methods: {
    applyMask(value, mask, masked = true) {
      value = value || "";
      var iMask = 0;
      var iValue = 0;
      var output = "";
      while (iMask < mask.length && iValue < value.length) {
        var cMask = mask[iMask];
        var masker = this.tokens[cMask];
        var cValue = value[iValue];
        if (masker) {
          if (masker.pattern.test(cValue)) {
            output += masker.transform ? masker.transform(cValue) : cValue;
            iMask++;
          }
          iValue++;
        } else {
          if (masked) output += cMask;
          if (cValue === cMask) iValue++;
          iMask++;
        }
      }
      return output;
    }
  },
  computed: {
    maskedValue: {
      get() {
        if (this.value === this.currentValue) {
          return this.currentMask;
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.currentMask = this.applyMask(this.value, this.maskT, true);
          return this.currentMask;
        }
      },
      set(newValue) {
        const el = this.$el;
        var currentPosition = el.selectionEnd;

        var lastMask = this.currentMask;

        el.value = this.currentMask = this.applyMask(newValue, this.maskT);

        if (this.currentMask.length <= lastMask.length) {
          el.setSelectionRange(currentPosition, currentPosition);
        } else {
          if (
            newValue.substring(0, currentPosition) ==
            this.currentMask.substring(0, currentPosition)
          ) {
            el.setSelectionRange(currentPosition, currentPosition);
          } else {
            el.setSelectionRange(currentPosition + 1, currentPosition + 1);
          }
        }
        this.currentValue = this.applyMask(newValue, this.maskT, this.masked);
        this.$emit("input", this.currentValue);
      }
    }
  }
};
</script>

<style lang="scss">
.input-mascked {
  width: 100%;
  height: 52px;
  background: #f0f0f0;
  border-radius: 30px;
  padding: 0px 20px;
  border: none;
  outline: none;
  font-size: 16px;
  padding-top: 20px;
  &:hover {
    background: #e0e0e0;
  }
  &:focus {
    border: none;
  }
}
</style>
